import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { KeyRound } from "lucide-react";
import logoFull from "@/assets/logo-full.png";

const Maintenance = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("We are currently performing scheduled maintenance. Please check back soon.");

  useEffect(() => {
    const fetchMaintenanceMessage = async () => {
      const { data } = await supabase
        .from("maintenance_settings")
        .select("message")
        .single();
      
      if (data?.message) {
        setMessage(data.message);
      }
    };

    fetchMaintenanceMessage();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white p-6 relative">
      <button
        onClick={() => navigate('/admin-login')}
        className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 
                   opacity-40 hover:opacity-100 transition-opacity"
        aria-label="Admin login"
        title="Admin login"
      >
        <KeyRound className="w-6 h-6 text-gray-600" />
      </button>
      <div className="text-center max-w-2xl">
        <img 
          src={logoFull} 
          alt="Logo" 
          className="mx-auto mb-8 h-32 w-auto"
          fetchPriority="high"
          width={330}
          height={128}
        />
        <h1 className="text-4xl font-bold mb-6 text-gray-900">
          Maintenance Mode
        </h1>
        <p className="text-xl text-gray-600 whitespace-pre-wrap">
          {message}
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
